<template>
  <div class="flex flex-col gap-y-10 md:gap-y-10 mb-10 md:mb-10">
    <MoleculeModalRowButton v-for="(row, i) in rows" :key="i" :item="row" />
  </div>
</template>

<script>
import MoleculeModalRowButton from './MoleculeModalRowButton'

export default {
  name: 'MoleculeModalTrainerRowButtons',
  components: {
    MoleculeModalRowButton,
  },
  props: ['trainer'],
  computed: {
    rows() {
      const hasFilials = this.trainer.filial && this.trainer.filial.length
      const hasPersonalTrainings = this.trainer.personalTrainings && this.trainer.personalTrainings.length
      const hasGroupTrainings = this.trainer.groupTrainings && this.trainer.groupTrainings.length
      const categories = []
      this.trainer?.custom_fields?.forEach(field => {
        if (field?.key?.value === '1') {
          categories.push({ title: field.name })
        }
      })
      return [
        hasFilials && {
          title: this.trainer.function ? `${this.trainer.function} в` : 'В клубе',
          controls: this.trainer.filial.map(({ title, slug }) => ({ title, to: slug && `/clubs/${slug}` })),
        },
        hasPersonalTrainings && {
          title: 'Персональный тренинг',
          controls: this.trainer.personalTrainings.map(({ name }) => ({ title: name })),
        },
        categories.length && {
          title: 'Персональный тренинг',
          controls: categories,
        },
        hasGroupTrainings && {
          title: 'Групповые тренировки',
          controls: this.trainer.groupTrainings
            .map(({ name, id }) => ({
              title: name,
              to: `/timetable/${this.context.club}/adult?trainer=${this.trainer.id}&training=${id}`,
            }))
            .concat([
              {
                title: 'Расписание групповых тренировок',
                to: `/timetable/${this.context.club}/adult?trainer=${this.trainer.id}`,
                class: 'btn-fill btn-inverted',
              },
            ]),
        },
      ].filter(Boolean)
    },
  },
}
</script>
